// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dot {
    width: 6px;
    height: 6px;
    background-color: #555;
    border-radius: 50%;
    display: inline-block;
    animation: blink 1.4s infinite both;
  }
  .dot:nth-child(2) {
    animation-delay: 0.2s;
  }
  .dot:nth-child(3) {
    animation-delay: 0.4s;
  }
  
  @keyframes blink {
    0%, 80%, 100% { opacity: 0; }
    40% { opacity: 1; }
  }
  `, "",{"version":3,"sources":["webpack://./src/pages/ChatPage/ChatPage.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,qBAAqB;IACrB,mCAAmC;EACrC;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;;EAEA;IACE,gBAAgB,UAAU,EAAE;IAC5B,MAAM,UAAU,EAAE;EACpB","sourcesContent":[".dot {\n    width: 6px;\n    height: 6px;\n    background-color: #555;\n    border-radius: 50%;\n    display: inline-block;\n    animation: blink 1.4s infinite both;\n  }\n  .dot:nth-child(2) {\n    animation-delay: 0.2s;\n  }\n  .dot:nth-child(3) {\n    animation-delay: 0.4s;\n  }\n  \n  @keyframes blink {\n    0%, 80%, 100% { opacity: 0; }\n    40% { opacity: 1; }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
